import { QueryHookOptions, useQuery } from '@apollo/client';

import query from './userMenuInfo.graphql';

export default function useUserMenuInfoQuery(
  opts?: QueryHookOptions<UserMenuInfoQuery, UserMenuInfoQueryVariables>,
) {
  return useQuery<UserMenuInfoQuery, UserMenuInfoQueryVariables>(query, opts);
}
